import React from "react";

import Desktop from ".";
import VideoTutorial from "../VideoTutorial";

import MaximizeGame from "../MaximizeGame";
import MaximizeGameV2 from "../MaximizeGameV2";
import MaximizeGameV4 from "../MaximizeGameV4";
import MaximizeTotoGame from "../MaximizeTotoGame";
import MaximizeMachineGame from "../MaximizeMachineGame";

import { isMachineGame, isV2Game, isV4Game, isTotoGame } from "@/modules/gamePcode";
import { activateBetGroup, activateUnsubmittedTicketRow, addUnsubmittedTicketRow, removeBet, removeTicket } from "@/modules/commonMachineGame";
import { addNumberM26, removeNumberM26 } from "@/modules/games/LottoGame";
import { addAnimal, removeAnimal } from "@/modules/games/ShioBalls";
import { addNumberM30, removeNumberM30 } from "@/modules/games/5D";
import { addNumberM42, removeNumberM42 } from "@/modules/games/Pinball";

/**
 * Game renderer bridge
 */
export default function gameFragment(this: Desktop) {
	const
		{
			v1Props,
			v2v4Props,
			totoProps
		} = this,
		{
			games,
			timers,
			activeGamePcodes,
			maximisedGamePcode
		} = this.state,
		isTotoGameMaximised = isTotoGame(maximisedGamePcode),
		gamePcodes = Object.keys(games);

	return (
		<div className="sl-wrapper">
			{this.transactionHistoryPopupFragment()}
			{this.resultHistoryPopupFragment()}
			{this.infoNewsFragment()}

			<div className={"sl-container" + (isTotoGameMaximised ? " v5" : "")}>
				{
					gamePcodes.map(pcode => {
						const
							game = games[pcode],
							timerData = timers[pcode];

						if (!activeGamePcodes.includes(pcode) &&
							!game.active)
							return null;

						const [machineGame, v2Game, v4Game, totoGame] = [
							isMachineGame(pcode),
							isV2Game(pcode),
							isV4Game(pcode),
							isTotoGame(pcode)
						];

						return (
							totoGame ? (
								<MaximizeTotoGame
									key={`toto_g_${pcode}`}
									data={game}

									{...totoProps}
								/>
							) : v4Game ? (
								<MaximizeGameV4
									key={`v4g_${pcode}`}
									data={game}
									timerData={timerData}

									// For FanTan
									showHiddenRoadmap={this.state.showHiddenRoadmap}
									toggleHiddenRoadmap={this.toggleHiddenRoadmap.bind(this)}

									{...v2v4Props}
								/>
							) : v2Game ? (
								<MaximizeGameV2
									key={`v2g_${pcode}`}
									data={game}
									timerData={timerData}

									{...v2v4Props}
								/>
							) : machineGame ? (
								<MaximizeMachineGame
									key={`mg_${pcode}`}
									data={game}
									timerData={timerData}

									{...v1Props}

									// Machine Games
									removeTicket={removeTicket.bind(this)}
									removeBet={removeBet.bind(this)}

									activateBetGroup={activateBetGroup.bind(this)}

									activateUnsubmittedTicketRow={activateUnsubmittedTicketRow.bind(this)}
									addUnsubmittedTicketRow={addUnsubmittedTicketRow.bind(this)}

									// Lotto
									addNumberM26={addNumberM26.bind(this)}
									removeNumberM26={removeNumberM26.bind(this)}

									// Shio Fights
									addAnimal={addAnimal.bind(this)}
									removeAnimal={removeAnimal.bind(this)}

									// 5D
									addNumberM30={addNumberM30.bind(this)}
									removeNumberM30={removeNumberM30.bind(this)}

									// Pinball
									addNumberM42={addNumberM42.bind(this)}
									removeNumberM42={removeNumberM42.bind(this)}
								/>
							) : (
								<MaximizeGame
									key={`v1g_${pcode}`}
									data={game}
									timerData={timerData}

									{...v1Props}
								/>
							)
						);
					})
				}

				{
					this.hasActiveGame
						? <VideoTutorial
							pcode={this.state.maximisedGamePcode}
						/>
						: null
				}
			</div>
		</div>
	);
}